import React from 'react';

import { InsideUserMenu } from '@/components/layout/InsideUserMenu';

/** Non-chat feature sidebar: name + email + ⋯ — same account dropdown as the module rail avatar. */
export function FeatureSidebarAccountFooter({ L }) {
    const {
        user,
        userRole,
        userMenuOpen,
        userMenuAnchor,
        setUserMenuOpen,
        setUserMenuAnchor,
        userMenuItems,
        handleUserMenuClick,
        getUserInitials,
        getUserName,
        currentUserAvatarColor,
        currentUserAvatarUrl,
        copyValue,
    } = L;

    return (
        <InsideUserMenu
            variant="feature"
            anchor="feature"
            userMenuOpen={userMenuOpen}
            userMenuAnchor={userMenuAnchor}
            setUserMenuOpen={setUserMenuOpen}
            setUserMenuAnchor={setUserMenuAnchor}
            user={user}
            userRole={userRole}
            userMenuItems={userMenuItems}
            handleUserMenuClick={handleUserMenuClick}
            getUserInitials={getUserInitials}
            getUserName={getUserName}
            currentUserAvatarColor={currentUserAvatarColor}
            currentUserAvatarUrl={currentUserAvatarUrl}
            copyValue={copyValue}
        />
    );
}
